export const QUERIES = {
  CART: 'cart',
  CUSTOMER: 'customer',
};
